import React from "react";
import Book from "../Book/Book";
import PropTypes from "prop-types";
import { LoremIpsum } from "lorem-ipsum";
import { payoneerLink } from "../../Constants";
const BookShelf = ({ books, shelfname }) => {
  const lorem = new LoremIpsum({
    sentencesPerParagraph: {
      max: 8,
      min: 4,
    },
    wordsPerSentence: {
      max: 16,
      min: 4,
    },
  });

  const name1 = lorem.generateWords(2);
  const name2 = lorem.generateWords(3);
  const title = lorem.generateWords(3);

  return (
    <div className="bookshelf">
      <h2
        style={{
          display:
            shelfname.length === 0 || books.length === 0 ? "none" : "block",
        }}
        className="bookshelf-title"
      >
        {shelfname}
      </h2>
      <div className="bookshelf-books">
        <ol className="books-grid">
          <li
            style={{
              display:
                shelfname === "Currently Reading" || shelfname === ""
                  ? "inline"
                  : "none",
            }}
            key={Math.random().toString(36).substr(-8)}
          >
            <Book
              key={Math.random().toString(36).substr(-8)}
              theBook={{
                isAd: true,
                previewLink: payoneerLink,
                title: title,
                authors: [name1, name2],
                imageLinks: {
                  smallThumbnail: "https://picsum.photos/128/192",
                },
              }}
            />
          </li>
          {books.map((book) => (
            <li key={book.id}>
              <Book
                key={Math.random().toString(36).substr(-8)}
                theBook={book}
              />
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

BookShelf.prototype = {
  book: PropTypes.object.isRequired,
  shelfname: PropTypes.string.isRequired,
};
export default BookShelf;
